module.exports = __webpack_public_path__ + "img/donkey-kong-min.d3f3dc86.png";